import { useNavigate, Link } from "react-router-dom";
import { motion } from "framer-motion";
import { IMAGES } from "@/data/content";

export const Footer = ({ onJoin }) => {
  const navigate = useNavigate();

  return (
    <footer className="relative w-full border-t border-[#C5A059]/10 bg-[#070707]" data-testid="footer">
      <div className="mx-auto max-w-[1600px] px-6 py-24 md:px-12 md:py-32">
        <div className="flex flex-col items-center text-center">
          <img src={IMAGES.logo} alt="Sybils Society" className="h-32 w-auto object-contain [filter:drop-shadow(0_0_40px_rgba(197,160,89,0.28))]" />
          <p className="overline mt-6">Sybils Society — The Return of the Matriarchs</p>
          <motion.h2
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 1 }}
            className="mt-8 max-w-3xl font-serif text-[clamp(2rem,5vw,4rem)] font-light leading-[1.05] tracking-tight text-white"
          >
            The council is <span className="italic text-[#C5A059]">listening</span>.
          </motion.h2>
          <p className="mt-6 max-w-md text-base font-light text-white/50">
            Ancient intuition for a new era. Entry to the Inner Sanctum is by
            audience only.
          </p>

          <div className="mt-10 flex flex-col items-center gap-4 sm:flex-row">
            <button
              onClick={() => navigate("/gate")}
              className="cta-glow rounded-full bg-[#C5A059] px-9 py-4 text-xs font-medium uppercase tracking-[0.24em] text-[#050505] transition-transform duration-300 hover:-translate-y-1"
              data-testid="footer-gate-btn"
            >
              Ascend to the Gate
            </button>
            <button
              onClick={onJoin}
              className="rounded-full border border-[#C5A059]/40 px-9 py-4 text-xs font-light uppercase tracking-[0.24em] text-[#C5A059] transition-colors duration-300 hover:bg-[#C5A059] hover:text-[#050505]"
              data-testid="footer-join-btn"
            >
              Join the Outer Circle
            </button>
          </div>
        </div>

        <div className="mt-24 flex flex-col items-center gap-8 border-t border-[#C5A059]/10 pt-8">
          <div className="flex flex-wrap items-center justify-center gap-x-8 gap-y-3">
            <Link
              to="/legal/privacy"
              className="text-xs font-light uppercase tracking-[0.2em] text-white/40 transition-colors duration-300 hover:text-[#C5A059]"
              data-testid="footer-link-privacy"
            >
              Privacy
            </Link>
            <Link
              to="/legal/terms"
              className="text-xs font-light uppercase tracking-[0.2em] text-white/40 transition-colors duration-300 hover:text-[#C5A059]"
              data-testid="footer-link-terms"
            >
              Terms of Service
            </Link>
            <Link
              to="/legal/accessibility"
              className="text-xs font-light uppercase tracking-[0.2em] text-white/40 transition-colors duration-300 hover:text-[#C5A059]"
              data-testid="footer-link-accessibility"
            >
              Accessibility
            </Link>
          </div>
          <div className="flex w-full flex-col items-center justify-between gap-4 text-xs font-light uppercase tracking-[0.2em] text-white/30 md:flex-row">
            <span>Sybils Society — The Return of the Matriarchs</span>
            <span>Lead from the root. Rise from the lineage.</span>
            <span>© {new Date().getFullYear()}</span>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
